// const sendMessageState = {
//   Success: '发送成功',
//   Error: '发送失败',
//   Sending: '正在发送'
// }
const sendMessageState = {
  Success: 200,
  Error: 3005,
  Sending: 3001
}
export {
  sendMessageState
}



// WEBPACK FOOTER //
// ./src/enum/SendMessage.js